import { combineReducers } from 'redux';
import galleryReducer from 'app/reducers/galleryReducer';
import screenReducer from 'shared/reducers/screenReducer';
import modalReducer from 'shared/reducers/modalReducer';
import navReducer from 'shared/reducers/navReducer';
import photoSwipeReducer from 'shared/reducers/photoSwipeReducer';
import selectionReducer from 'shared/reducers/selectionReducer';
import messagesReducer from 'shared/reducers/messagesReducer';
import userReducer from 'shared/reducers/userReducer';

export default combineReducers({
  galleryReducer,
  screenReducer,
  modalReducer,
  navReducer,
  photoSwipeReducer,
  selectionReducer,
  messagesReducer,
  userReducer
});
